"use client"

import { useRouter } from "next/navigation"

import TextLinkWithArrow from "@/components/ui/components/text-link-with-arrow"

export default function AccountBackLinkClient(props: { label: string | undefined }) {
  const r = useRouter()
  return (
    <p className={"pb-2"}>
      <TextLinkWithArrow
        prefetch={false}
        href=""
        onClick={(e) => {
          e.preventDefault()
          r.back()
        }}
        arrowDirection={"left"}
        className={"inline-block text-sm text-gray-500 hover:text-primary"}
      >
        {props.label}
      </TextLinkWithArrow>
    </p>
  )
}
